var strokeImage12v = {
  "10": {
    img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-12v-10.png?v=1764193190",
    link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-12v-10.pdf?v=1764191520"
  },
  "15": {
    img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-12v-15.png?v=1764193189",
    link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-12v-15.pdf?v=1764191520"
  },
  "20": {
    img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-12v-20.png?v=1764193189",
    link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-12v-20.pdf?v=1764191520"
  },
  "25": {
    img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-12v-25.png?v=1764193189",
    link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-12v-25.pdf?v=1764191520"
  },
  "30": {
    img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-12v-30.png?v=1764193190",
    link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-12v-30.pdf?v=1764191520"
  },
  "35": {
    img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-12v-35.png?v=1764193190",
    link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-12v-35.pdf?v=1764191520"
  },
  "40": {
    img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-12v-40.png?v=1764193189",
    link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-12v-40.pdf?v=1764191520"
  }
};

var strokeImages24v = {
  "10": {
    img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-24v-10.png?v=1764193190",
    link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-24v-10.pdf?v=1764191520"
  },
  "15": {
    img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-24v-15.png?v=1764193189",
    link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-24v-15.pdf?v=1764191520"
  },
  "20": {
    img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-24v-20.png?v=1764193189",
    link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-24v-20.pdf?v=1764191520"
  },
  "25": {
    img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-24v-25.png?v=1764193189",
    link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-24v-25.pdf?v=1764191520"
  },
  "30": {
    img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-24v-30.png?v=1764193190",
    link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-24v-30.pdf?v=1764191520"
  },
  "35": {
    img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-24v-35.png?v=1764193189",
    link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-24v-35.pdf?v=1764191520"
  },
  "40": {
    img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-24v-40.png?v=1764193189",
    link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-IND-2200-24v-40.pdf?v=1764191520"
  }
};


  jQuery(document).ready(function ($) {
  var strokeSelector = document.getElementById("strokeSelector");
  var voltageSelector = document.getElementById("voltageSelector");
  var strokeImage = document.getElementById("strokeImage");
  var imageLink = document.getElementById("imageLink");

  
  function updateImage() {
    var stroke = strokeSelector.value;
    var voltage = voltageSelector.value;
    var selectedMap = voltage === "12v" ? strokeImage12v : strokeImages24v;

    if (selectedMap[stroke]) {
      strokeImage.src = selectedMap[stroke].img;
      imageLink.href = selectedMap[stroke].link;
    }
  }
  function preloadImages(map) {
    Object.values(map).forEach(entry => {
      const img = new Image();
      img.src = entry.img;
    });
  }
  window.addEventListener('load', () => {
    setTimeout(() => {
      preloadImages(strokeImage12v);
      preloadImages(strokeImages24v);
    }, 500);
  });
  
  strokeSelector?.addEventListener("change", updateImage);
  voltageSelector?.addEventListener("change", updateImage);
  




  function bindDropdownListeners() {
    const dropdownToggles = document.querySelectorAll(".dropdown-trigger");
    dropdownToggles.forEach(trigger => {
      if (!trigger.dataset.listenerAdded) {
        trigger.dataset.listenerAdded = "true";
        trigger.addEventListener("click", () => {
        const detailsSection = trigger.nextElementSibling;
        if (detailsSection) {
          detailsSection.style.transition = "max-height 0.3s ease, padding 0.3s ease";

          if (detailsSection.classList.contains("open")) {
            // Close
            detailsSection.style.maxHeight = "0px";
            detailsSection.classList.remove("open");
          } else {
            // Open
            detailsSection.style.maxHeight = detailsSection.scrollHeight + "px";
            detailsSection.classList.add("open");

            // If content includes images, re-measure once they load
            detailsSection.querySelectorAll("img").forEach(img => {
              if (!img.complete) {
                img.addEventListener("load", () => {
                  if (detailsSection.classList.contains("open")) {
                    detailsSection.style.maxHeight = detailsSection.scrollHeight + "px";
                  }
                });
              }
            });
          }
        }
      });
      }
    });
  }
  // Product tab toggle
  let lastChecked = document.querySelector("input[type='radio'][name='productTabs']");
  document.querySelectorAll("input[type='radio'][name='productTabs']").forEach(radio => {
    radio.addEventListener("click", function () {
      if (lastChecked === this) {
        this.checked = false;
        lastChecked = null;
      } else {
        lastChecked = this;
      }
    });
  });

    const contentTarget = document.querySelector(".fg-product-additional-content");
    if (contentTarget) {
      const contentObserver = new MutationObserver(() => {
        bindDropdownListeners();
        hideNearestH2Above(".site-wrapper");
        setupYouTubeThumbnails();
      });
      contentObserver.observe(contentTarget, { childList: true, subtree: true });
    }

    // Function to hide nearest <h2> above a target
    function hideNearestH2Above(selector) {
      const element = document.querySelector(selector);
      if (!element) return;

      let h2 = element.previousElementSibling;
      while (h2 && h2.tagName !== "H2") {
        h2 = h2.previousElementSibling;
      }

      if (h2) h2.style.display = "none";
    }

    
    function setupYouTubeThumbnails() {
      var youtube = document.querySelectorAll(".youtubeVideo:not([data-initialized])");
      youtube.forEach(el => {
        el.dataset.initialized = "true";
        el.addEventListener("click", function () {
          var iframe = document.createElement("iframe");
          iframe.setAttribute("frameborder", "0");
          iframe.setAttribute("allowfullscreen", "");
          iframe.setAttribute("allow", "autoplay");
          iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1");
          this.innerHTML = "";
          this.appendChild(iframe);
        });
      });
    }

    // Initial bindings
    bindDropdownListeners();
    hideNearestH2Above(".site-wrapper");
    setupYouTubeThumbnails();

  });
